export default {
  toasts: {
    auth_token_invalid: 'Token de autentificare invalid',
    host_access_refused:
      'Această adresă aparține unui partener din care contul dvs. nu face parte. Autentificați-vă la adresa dvs.',
  },
};
